import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class EssensysRequestContainsValidationError extends CodedError {
  static get errorName() {
    return errorCodes.essensysRequestContainsValidationError.code;
  }

  constructor(
    message: string = errorCodes.essensysRequestContainsValidationError.message
  ) {
    super(message);
    this.code = errorCodes.essensysRequestContainsValidationError.code;
    this.message = `${message} ${errorCodes.essensysRequestContainsValidationError.code}`;
    this.name = errorCodes.essensysRequestContainsValidationError.name;
  }
}
